import * as Yup from "yup";
import { validateIranianNationalId } from "../reports/userValidationSchema";

// const numericOnly = /^\d+$/;

export const attendeeSchema = Yup.object().shape({
  name: Yup.string().optional(),
  mobile: Yup.string().optional(),
  national_code: Yup.string()
    .trim("کد ملی نباید فقط از فاصله تشکیل شده باشد")
    .matches(/^[0-9]+$/, " لطفا فقط عدد وارد کنید")
    .matches(/^\d{10}$/, "کد ملی باید دقیقاً 10 رقم باشد")
    .test("iran-national-id", "کد ملی معتبر نیست", (value) =>
      validateIranianNationalId(value || "")
    )
    .required("فیلد را پر کنید"),
  used_count: Yup.string().optional(),
}).test('at-least-national-code', '', function(value) {
  // فقط کد ملی را چک می‌کنیم و بقیه فیلدها را نادیده می‌گیریم
  return value.national_code ? true : false;
});;

// export const TicketInSpecialValidationSchema = Yup.object().shape({
//   matchId: Yup.string().required("الزامی است"),
//   profilePlatformId: Yup.string().required("الزامی است"),
//   attendees: Yup.lazy((val) =>
//     Array.isArray(val)
//       ? Yup.array().of(attendeeSchema).min(1, "حداقل یک هوادار باید اضافه شود.")
//       : Yup.string().required("اضافه کردن هوادار الزامی است")
//   ),
// });
export const TicketInSpecialValidationSchema = Yup.object().shape({
  matchId: Yup.string().required("الزامی است"),
  profilePlatformId: Yup.string().required("الزامی است"),
  attendees: Yup.array()
    .of(attendeeSchema)
    .min(1, "حداقل یک هوادار باید اضافه شود."),
  operatorId: Yup.number()
    .required('انتخاب سازمان اجباری است')
    .min(1, 'انتخاب سازمان اجباری است'),
    male: Yup.boolean().required('جنسیت الزامی است'),

});